import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import { DiagnosisEnergyVectorsReadDTO, DiagnosisEnergyVectorsCreateDTO } from '../generated/api-client';

export const useDiagnosisEnergyVectors = () => {
  return useQuery<DiagnosisEnergyVectorsReadDTO[]>('diagnosisEnergyVectors', () => apiClient.list_items_diagnosis_energy_vectors__get());
};

export const useDiagnosisEnergyVectorsById = (id: string) => {
  return useQuery<DiagnosisEnergyVectorsReadDTO>(
    ['diagnosisEnergyVectors', id],
    () => apiClient.get_item_diagnosis_energy_vectors__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useDiagnosisEnergyVectorsByDiagnosisId = (diagnosisId: string) => {
  return useQuery<DiagnosisEnergyVectorsReadDTO[]>(
    `diagnosis-energy-vectors-${diagnosisId}`,
    () => apiClient.search_by_diagnosis_id_diagnosis_energy_vectors_search_by_diagnosis_id__diagnosis_id__get(diagnosisId),
    {
      enabled: !!diagnosisId,
    }
  );
};

export const useCreateDiagnosisEnergyVectors = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisEnergyVectorsReadDTO, Error, DiagnosisEnergyVectorsCreateDTO>(
    (data) => apiClient.create_item_diagnosis_energy_vectors__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisEnergyVectors');
        queryClient.invalidateQueries(['diagnosisEnergyVectors', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-energy-vectors-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-energy-vectors-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-energy-vectors-');
            }
            return false;
          },
        });
      },
    }
  );
};

export const useUpdateDiagnosisEnergyVectors = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisEnergyVectorsReadDTO, Error, { id: string; data: DiagnosisEnergyVectorsCreateDTO }>(
    ({ id, data }) => apiClient.update_item_diagnosis_energy_vectors__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisEnergyVectors');
        queryClient.invalidateQueries(['diagnosisEnergyVectors', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-energy-vectors-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-energy-vectors-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-energy-vectors-');
            }
            return false;
          },
        });
      },
    }
  );
};

export const useDeleteDiagnosisEnergyVectors = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    (id) => apiClient.delete_item_diagnosis_energy_vectors__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisEnergyVectors');
        queryClient.invalidateQueries(['diagnosisEnergyVectors', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-energy-vectors-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-energy-vectors-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-energy-vectors-');
            }
            return false;
          },
        });
      },
    }
  );
};

